module.exports = __webpack_public_path__ + "static/media/wizardRuinedSpell.0a7b55b0.gif";